import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/cartLocation.webp")